import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
      <div className="text-center max-w-2xl">
        <img 
          src="https://public.readdy.ai/ai/img_res/994872d3-d12a-41a9-b9a3-399c87796801.png" 
          alt="Practical Living Projects" 
          className="h-16 w-auto mx-auto mb-8"
        />
        <h1 className="text-5xl font-serif font-bold text-gray-900 mb-6">Practical Living Projects</h1>
        <p className="text-xl text-gray-600 mb-12">Insights on professional home installations and improvements</p>
        <Link 
          to="/blog" 
          className="inline-block px-8 py-4 bg-gray-900 text-white text-lg font-medium rounded-lg hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          View Articles
        </Link>
      </div>
    </div>
  );
}
